// shared-package/requests/index.ts
import { createAuthRequests } from "./auth";
import { createApiKeysRequests } from "./api-keys";
import { createContestsEditionStageTableEntriesRequests } from "./contests-edition-stage-table-entries";
import { createContestsEditionStageTableJudgesRequests } from "./contests-edition-stage-table-judges";
import { createContestsEditionStageTablesRequests } from "./contests-edition-stage-tables";
import { createContestsEditionsJudgesRequests } from "./contests-editions-judges";
import { createContestsEditionsRequests } from "./contests-editions";
import { createContestsEditionsStagesRequests } from "./contests-editions-stages";
import { createContestsEditionsStandingsRequests } from "./contests-editions-standings";
import { createContestsEditionSurveysRequests } from "./contests-edition-surveys";
import { createContestsEditionsStylesRequests } from "./contests-editions-styles";
import { createContestsRequests } from "./contests";
import { createDescriptorsGroupsRequests } from "./descriptors-groups";
import { createDescriptorsRequests } from "./descriptors";
import { createDiscountCodesRequests } from "./discount-codes";
import { createEntriesRequests } from "./entries";
import { createLeaguesRequests } from "./leagues";
import { createOrganizationsRequests } from "./organizations";
import { createParticipantsRequests } from "./participants";
import { createPaymentProvidersRequests } from "./payment-providers";
import { createScoresheetCommentsRequests } from "./scoresheet-comments";
import { createScoresheetSchemasRequests } from "./scoresheet-schemas";
import { createScoresheetsRequests } from "./scoresheets";
import { createStaffMembersRequests } from "./staff-members";
import { createStylesRequests } from "./styles";
import { createUserRequests } from "./user";
import { createVersionRequests } from "./version";
import { createJudgesRequests } from "./judges";
import createTranslationsRequests from "./translations";
import { createFlawsRequests } from "./flaws";
import { createOrdersRequests } from "./orders";
import { createCertificationStepJudgesRequests } from "./certification-step-judges";
import { createCertificationStepScoresheetsRequests } from "./certification-step-scoresheets";
import { createCertificationStepsRequests } from "./certification-steps";
import { createCertificationsRequests } from "./certifications";
import { createContestsEditionJudgeFinalsEntriesRequests } from "./contests-edition-judge-finals-entries";
import { createJudgingProgrammeJudgesRequests } from "./judging-programme-judges";
import { createJudgingProgrammeQuestionsRequests } from "./judging-programme-questions";
import { createJudgingProgrammesRequests } from "./judging-programmes";
import { createPaymentsRequests } from "./payments";
import { createBreweriesRequests } from "./breweries";
import { createNamespacesRequests } from "./namespaces";
import { createLocalesRequests } from "./locales";
import { createMessagesRequests } from "./messages";
import { createAchievementsRequests } from "./achievements";
import { createUsersAchievementsRequests } from "./users-achievements";
import { createTiersRequests } from "./tiers";
import { createContactRequests } from "./contact-requests";
import { createNewsletterSubscriptionRequests } from "./newsletter-subscriptions";
import { createContestsEditionLogsRequests } from "./contests-edition-logs";
import { createFlightsRequests } from "./flights";
import { createQARequests } from "./qa";
export const createRequests = (api) => ({
    auth: createAuthRequests(api),
    apiKeys: createApiKeysRequests(api),
    achievements: createAchievementsRequests(api),
    usersAchievements: createUsersAchievementsRequests(api),
    breweries: createBreweriesRequests(api),
    contestsEditionsStageTableEntries: createContestsEditionStageTableEntriesRequests(api),
    contestsEditionStageTables: createContestsEditionStageTablesRequests(api),
    contestsEditionsStageTableJudges: createContestsEditionStageTableJudgesRequests(api),
    contestsEditionLogs: createContestsEditionLogsRequests(api),
    contestsEditionsJudges: createContestsEditionsJudgesRequests(api),
    contestsEditions: createContestsEditionsRequests(api),
    contestsEditionsStages: createContestsEditionsStagesRequests(api),
    contestsEditionsStandings: createContestsEditionsStandingsRequests(api),
    contestsEditionSurveys: createContestsEditionSurveysRequests(api),
    contestsEditionsStyles: createContestsEditionsStylesRequests(api),
    contests: createContestsRequests(api),
    descriptorsGroups: createDescriptorsGroupsRequests(api),
    descriptors: createDescriptorsRequests(api),
    discountCodes: createDiscountCodesRequests(api),
    entries: createEntriesRequests(api),
    leagues: createLeaguesRequests(api),
    locales: createLocalesRequests(api),
    namespaces: createNamespacesRequests(api),
    messages: createMessagesRequests(api),
    organizations: createOrganizationsRequests(api),
    participants: createParticipantsRequests(api),
    paymentProviders: createPaymentProvidersRequests(api),
    payments: createPaymentsRequests(api),
    scoresheetComments: createScoresheetCommentsRequests(api),
    scoresheetSchemas: createScoresheetSchemasRequests(api),
    scoresheets: createScoresheetsRequests(api),
    staffMembers: createStaffMembersRequests(api),
    styles: createStylesRequests(api),
    tiers: createTiersRequests(api),
    users: createUserRequests(api),
    judges: createJudgesRequests(api),
    version: createVersionRequests(api),
    translations: createTranslationsRequests(api),
    flaws: createFlawsRequests(api),
    orders: createOrdersRequests(api),
    certificationStepJudges: createCertificationStepJudgesRequests(api),
    certificationStepScoresheets: createCertificationStepScoresheetsRequests(api),
    certificationSteps: createCertificationStepsRequests(api),
    certifications: createCertificationsRequests(api),
    contestsEditionJudgeFinalsEntries: createContestsEditionJudgeFinalsEntriesRequests(api),
    judgingProgrammeJudges: createJudgingProgrammeJudgesRequests(api),
    judgingProgrammeQuestions: createJudgingProgrammeQuestionsRequests(api),
    judgingProgrammes: createJudgingProgrammesRequests(api),
    contactRequests: createContactRequests(api),
    newsletterSubscriptions: createNewsletterSubscriptionRequests(api),
    flights: createFlightsRequests(api),
    qa: createQARequests(api),
});
//# sourceMappingURL=index.js.map